import { Flex } from '@banhala/ui-kit';
import type { IconListProps } from './types';
import { FixedColumnIconList } from './FixedColumnIconList';
import { isNil } from '../../../../utils';

export const FiveColIconList = ({ entity }: IconListProps) => {
  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  return (
    <Flex.Column padding={{ horizontal: 8, bottom: 24 }} gap={4}>
      <FixedColumnIconList
        entity={entity}
        column={5}
        iconSize="medium"
        analyticsEventName="CLICK_FIVE_COL_ICON_LIST"
      />
    </Flex.Column>
  );
};
